<template>
  <header id="app-headers" v-if="isLoggedIn">
    <div id="app-header" class="p-1 clearfix bg-dark">
      <button class="btn btn-secondary btn-disconnect" title="Se déconnecter" @click="logout"><i class="fa fa-sign-out-alt"></i></button>
      <router-link v-if="backLink" class="back-link" :to="backLink">
        <i class="fa fa-long-arrow-alt-left"></i> <span class="d-none d-md-inline">{{ backLink.label || 'Retour' }}</span>
      </router-link>
      <h1 v-if="title">{{ title }}</h1>
    </div>
    <div v-if="$slots['page-header']" id="page-header" class="p-1">
      <slot name="page-header" />
    </div>
  </header>
  <div class="container">
    <slot />
    <div id="audio-bar" class="pt-1 bg-dark">
      <AudioPlayer />
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AudioPlayer from "@/components/AudioPlayer";

export default {
  name: 'DefaultLayout',
  components: { AudioPlayer },
  props: {
    title: {
      type: String,
      default: ''
    },
    backLink: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn"])
  },
  methods: {
    ...mapActions(["verifyLogin", "logoutUser"]),
    logout() {
      this.logoutUser().then(() => this.$router.push('/login'));
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#app-header {
  min-height: 3rem;
  text-align: center;
}
#app-header .back-link {
  position: absolute;
  left: 17px;
  top: 13px;
  color: #fff;
}
#app-header .back-link:hover {
  text-decoration: none;
}
#page-header {
  background-color: #efefef;
  border-bottom: 1px solid #c1c1c1;
}
#app-headers,
#audio-bar {
  background: white;
  z-index: 2;
}
#app-headers {
  position: sticky;
  top: 0;
}
#app-headers + * {
  margin-top: 3px;
}
.btn-disconnect {
  position: absolute;
  right: 5px;
}
#audio-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
h1 {
  color: #fff;
  font-size: 1.5rem;
  line-height: 2.5rem;
  margin: 0;
}
</style>
